import { CONSTANTS } from '../attributes/DeviceHealth';
import FilterTranslatorConverter from '../../attributes/filters/FilterTranslatorConverter';

/**
 * filterTranslator returns an object with a key of the constants and a value of a function that returns the search filter like this:
 * {
  [CONSTANTS.HIGH_TEMP] : () => {
    return {
      type : 'exists',
      field : `data/deviceHealth@/[${CONSTANTS.HIGH_TEMP}]`,
    }
  },...
 */

let filterTranslator = Object.fromEntries(Object.values(CONSTANTS).map(key => [key, () => ({
  type: 'exists',
  field: `data/deviceHealth@/[${key}]`
})]));

// adds None of These filter which looks for locators with no device health issues
const noneOfTheseFilter = {
  noneOfThese: () => {
    return {
      type: 'exists',
      field: 'data/deviceHealth@',
      not: true
    };
  }
};
filterTranslator = {
  ...filterTranslator,
  ...noneOfTheseFilter
};
export default FilterTranslatorConverter.create('locator.deviceHealth', filterTranslator);